// @flow
import { makeGetRequest } from '../utils'

import type { ResponseAPI } from '../types/api'
import type { Category } from '../types/categories'

export const getChannelCategories = (domain: string, serviceSpec: string): Promise<ResponseAPI<Category>> =>
  makeGetRequest(`${domain}/client/api/servicespec/${serviceSpec}/tv/categories`)
